import cx from "classnames";
import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, ButtonGroup } from "reactstrap";
import { enablesidebarXFP } from "../../reducers/Header";
import * as UsersService from "../../services/users/api_user";
import HeaderLogo from "../AppLogo";
import HeaderRightDrawer from "./Components/HeaderRightDrawer";
import UserBox from "./Components/UserBox";

class Header extends React.Component {
  render() {
    let {
      headerBackgroundColor,
      enableMobileMenuSmall,
      enableHeaderShadow,
      enablesidebarXFP,
      sidebarXFP,
    } = this.props;

    const grantAccess = UsersService.getAccessControl();


    let xfpActiveTab = true;
    if (grantAccess === 1) {
      xfpActiveTab = true;
    } else if (grantAccess === 2) {
      xfpActiveTab = true;
    } else {
      xfpActiveTab = false;
    }

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          className={cx("app-header", headerBackgroundColor, {
            "header-shadow": enableHeaderShadow,
          })}
          transitionName="HeaderAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}
        >
          <HeaderLogo />

          <div
            className={cx("app-header__content", {
              "header-mobile-open": enableMobileMenuSmall,
            })}
          >
            <div className="app-header-left">
              <ButtonGroup size="sm" className="mb-2">
                {grantAccess === 1 || grantAccess === 2 ? (
                  <Link to="/pica_cs_vz">
                    <Button
                      className="btn-square"
                      outline
                      color="primary"
                      onClick={() => enablesidebarXFP(sidebarXFP)}
                      active={xfpActiveTab}
                    >
                      XFP
                    </Button>
                  </Link>
                ) : null}
              </ButtonGroup>
            </div>
            <div className="app-header-right">
              <UserBox />
              <HeaderRightDrawer />
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
  closedSmallerSidebar: state.ThemeOptions.closedSmallerSidebar,
  headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
  enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
  sidebarXFP: state.Header.sidebarXFP,
});

const mapDispatchToProps = (dispatch) => ({
  enablesidebarXFP: () => dispatch(enablesidebarXFP()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/Layout/AppHeader/index.js